import React, { useState, useContext, useEffect } from "react";
import TextareaAutosize from "react-textarea-autosize";
import { Trans } from "react-i18next";
import { ActividadContext } from "./ActividadesUtils/BlockWrapper";
import LoadingButton from "./ActividadesUtils/LoadingButton";
import Lightbox from "./ActividadesUtils/Lightbox/Lightbox";
import LightboxWrapper from "./ActividadesUtils/Lightbox/LightboxWrapper";
import ImagenValidada from "./ActividadesUtils/RecursosValidados/ImagenValidada";
import { shuffle } from "./ActividadesUtils/ActividadesUtils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor as ClassicEditor } from "ckeditor5-resize-nimbus-build/build/ckeditor";
import { htmlSupportConfig } from "../ActividadesUtils/FormularioUtils";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import GeneralModal from "../../../fragments/Modals/SimpleModal";
import ModalLg from "../../../fragments/Modals/ModalLg";

Modal.setAppElement("#root");

function PreguntasAbiertas({ preguntas, instrucciones, tipoOrden = "", isGeneratingPDF = false }) {
  const [inputList, setInputList] = useState([]);
  const [lightboxValue, setLightboxValue] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentEditing, setCurrentEditing] = useState(null);
  const [originalAnswer, setOriginalAnswer] = useState("");

  const activityContext = useContext(ActividadContext);

  const handleInput = (answer, inputId) => {
    const newInputList = inputList.map((el) => {
      if (el._id === inputId) return { ...el, answer };
      else return el;
    });
    setInputList(newInputList);
  };

  const calificar = () => {
    const dataToSave = inputList
      .filter((el) => el && el.answer)
      .map((el) => ({ answer: el.answer ? el.answer : "", _id: el._id }));
    console.log(dataToSave);
    activityContext.postCalificacionActividad(100, JSON.stringify(dataToSave));
  };

  const reordenarPreguntas = (preguntasArr) => {
    const listadoPreguntas = [...preguntasArr];
    if (tipoOrden === "AZAR") {
      return shuffle(listadoPreguntas);
    } else if (tipoOrden === "ORDENAR") {
      return listadoPreguntas.sort((a, b) => (a.orden > b.orden ? 1 : -1));
    } else {
      return listadoPreguntas;
    }
  };

  useEffect(() => {
    const userResponses = activityContext?.userData;
    if (userResponses && userResponses !== "") {
      const parsedSelected = JSON.parse(userResponses);
      const answeredList = preguntas.map((el) => {
        const savedAns = parsedSelected.find((ans) => ans._id === el._id);
        if (savedAns && savedAns.answer)
          return { ...el, answer: savedAns.answer };
        else return el;
      });
      setInputList(reordenarPreguntas(answeredList));
    } else {
      setInputList(reordenarPreguntas(preguntas));
    }
  }, []);

  const isLoading = activityContext?.loading;
  const isAnswered = inputList?.some((el) => el.answer);

  return (
    <div className="visor w-full">
      <Lightbox
        lightboxValue={lightboxValue}
        closeLightbox={() => setLightboxValue("")}
      />
      <ModalLg
        isOpen={modalIsOpen}
        toggleModal={() => setModalIsOpen(!modalIsOpen)}
      >
        <h2 className="text-xl font-bold mb-4"><Trans>Editar respuesta</Trans></h2>
        {currentEditing && (
          <CKEditor
            editor={ClassicEditor}
            data={currentEditing.answer || ""}
            config={{
              placeholder: " ",
              htmlSupport: htmlSupportConfig,
              toolbar: [
                "fontColor",
                "fontBackgroundColor",
                "|",
                "bold",
                "italic",
                "bulletedList",
                "numberedList",
                "blockQuote",
                "insertTable",
                "undo",
                "redo",
                "alignment",
                "outdent",
                "indent",
              ],
              table: {
                contentToolbar: [
                  "tableColumn",
                  "tableRow",
                  "mergeTableCells",
                  "tableProperties",
                  "tableCellProperties",
                ],
              },
            }}
            onChange={(_, editor) => {
              const data = editor.getData();
              const plainText = data
                .replace(/<[^>]*>/g, "")
                .replace(/&nbsp;/g, " ")
                .trim();
              if (plainText.length <= 1000) {
                handleInput(data, currentEditing._id);
              }
            }}
          />
        )}
        <div className="flex justify-end mt-4">
          <button
            onClick={() => {
              handleInput(originalAnswer, currentEditing._id);
              setModalIsOpen(false);
            }}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 mr-3"
          >
            Cancelar
          </button>
          <button
            onClick={() => setModalIsOpen(false)}
            className="px-4 py-2  text-white rounded-md hover:opacity-90 bg-nimbus"
          >
            Guardar y cerrar
          </button>
        </div>
      </ModalLg>

      <div
        style={{
          boxShadow: `rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px`,
        }}
        className="my-10 mx-auto p-4 md:px-10 py-14 bg-white rounded-2xl border border-[#ededed] w-full max-w-activity"
      >
        <div className="mx-auto">
          {instrucciones && (
            <div className="text-nimbus mb-10 text-left w-full mx-auto font-bold text-lg">
              {instrucciones}
            </div>
          )}

          {inputList.map(
            (el, index) =>
              el &&
              el.texto && (
                <div key={el._id} className="items-center mb-8 justify-between">
                  <div className="flex flex-col sm:flex-row items-center mb-10 flex-1">
                    {el.imagen && (
                      <>
                        <LightboxWrapper
                          handleClick={() => setLightboxValue(el.imagen)}
                        >
                          <ImagenValidada
                            src={el.imagen}
                            className="w-full md:w-48 square-image border rounded-[10px] bg-cover mb-3 sm:mb-0"
                          />
                        </LightboxWrapper>
                        <div className="mr-8"></div>
                      </>
                    )}
                    <div className="text-nimbus md:mr-4 flex-1 w-full md:w-auto mt-4 md:mt-0">
                      <div className="mb-3">
                        <span className="inline-block font-bold mr-1 text-lg">
                          {index + 1}.
                        </span>
                        <span dangerouslySetInnerHTML={{ __html: el.texto }} />
                      </div>
                      <div
                        className="mt-4 min-h-[2.5rem] rounded text-sm text-gray-800 border-b-2 border-lightBlue border-dashed bg-[#f7fcfe] px-2 pb-2 visor"
                        dangerouslySetInnerHTML={{ __html: el.answer }}
                        onClick={() => {
                          setCurrentEditing(el);
                          setOriginalAnswer(el.answer || "");
                          setModalIsOpen(true);
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              ),
          )}
        </div>

        {!isGeneratingPDF && (
          <div className={`custom-transition ${isAnswered ? "" : "opacity-50"}`}>
            <LoadingButton
              onClick={isAnswered ? calificar : undefined}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default PreguntasAbiertas;
